import { useRef } from 'react';

interface TimerHook {
  start: () => void;
  getTimePassed: () => number;
}

export const useTimer = (): TimerHook => {
  const startTimeRef = useRef<number | null>(null);

  const start = () => {
    startTimeRef.current = Date.now();
  };

  const getTimePassed = () => {
    if (startTimeRef.current === null) {
      return 0;
    }
    return Date.now() - startTimeRef.current;
  };

  return { start, getTimePassed };
};
